<template>
    <!-- <v-card color="grey lighten-2"> -->
    <!-- Container para Información: -->
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row justify-space-between>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>

                        <v-layout row align-center>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0" ref="contact_card">
                                    <v-card-text
                                        class="teal--text text--lighten-2 headline text-center"
                                    >
                                        <img height="140" :src="mainLogo" />
                                        <br />
                                        <b>Talentwise SC, México, Consultoría empresarial</b>
                                    </v-card-text>

                                    <v-card-text
                                        class="teal--text text--lighten-5 body-1 text-center"
                                    >
                                        WeWork Artz Pedregal
                                        <br />Torre 2, Piso 8
                                        <br />Blvd. Adolfo Ruiz Cortines 3720
                                        <br />Jardines del Pedregal
                                        <br />Ciudad de México, C.P. 01900
                                        <br />México
                                        <br />+52 (56) 4710-5613
                                        <p></p>
                                        <iframe
                                            :width="mapWidth"
                                            height="300"
                                            frameborder="0"
                                            scrolling="no"
                                            marginheight="0"
                                            marginwidth="0"
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3765.260755789278!2d-99.2219611!3d19.3144881!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cdff965c918235%3A0x994d8c0a11052a5e!2sArtz+Pedregal!5e0!3m2!1sen!2sus!4v1565890066974!5m2!1sen!2sus">
                                        </iframe>
                                        <br>
                                        <a href="mailto:info@twmexico.com">
                                            <b>info@twmexico.com</b>
                                        </a>
                                        <br />
                                        <a target="_new" href="http://www.twmexico.com">
                                            <b>www.twmexico.com</b>
                                        </a>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout row align-center>
                            <v-flex xs12 class="text-center" color="white">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            large
                                            class="tet-none"
                                            icon
                                            @click="onTwitter"
                                            v-on="on"
                                        >
                                            <img height="40" src="@/assets/twitter.png" />
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('follow-us')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Contacto',
    data() {
        return{
            bMounted: false, //Para saber si ya se pueden obtener las dimensiones de los componentes.
        };
    },
    
    created() {},

    mounted() {
        this.bMounted = true;
    },

    methods:
    {
        onTwitter()
        {
            window.open('https://twitter.com/talentwise_mex');
        },
        onClose()
        {
            this.showContactoTxt = false;
        }
    },

    computed:
    {
        ...mapGetters(['waitCursor', 'mainLogo']),

        showContactoTxt:
        {
            get()
            {
                return this.$store.getters.showContactoTxt;
            },
            set(showContactoTxt)
            {
                this.$store.dispatch('updateShowContactoTxt', showContactoTxt);
            }
        },

        mapWidth()
        {
            var width;
            if (this.$vuetify.breakpoint.xs)
            {
                width = '300px';
            }
            else
            if (this.$vuetify.breakpoint.sm)
            {
                width = '500px';
            }
            else
            if (this.bMounted)
            {
                console.log("card width = ", this.$refs.contact_card.$el.clientWidth)
                width = this.$refs.contact_card.$el.clientWidth - 100 + 'px';
            }
            else
            {
                width = '700px';
            }
            return width;
        },
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Contacto",
        "follow-us": "Síguenos en Twitter"
    },
    "en": {
        "title": "Contact Us",
         "follow-us": "Follow us on Twitter"
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.8);
}

a:link,
a:visited {
    color: #26a69a;
    text-decoration: none;
}

a:link:active,
a:visited:active {
    color: #26a69a;
}
</style>